import Dashboard from "views/Dashboard.js";
import { constants } from "utils/Constant";

var routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: constants.finalyze,
  },
];
export default routes;
